import { Grid2, Icon } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import { Box, Typography } from '@mui/material';
import { memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { UsageAnalyticsSummaryProps as Props } from './types';

export const ApiUsageAnalyticsSummary = memo(
  ({ className, title, total, latency, icon, loading }: Props) => {
    return (
      <Styled.Wrapper
        className={classnames('ApiUsageAnalyticsSummary', className)}
        sx={SX.root}
        container
        columns={48}
        xs={48}
      >
        <Grid2 xs={48} sm={48} md={30} lg={30} xl={30} sx={SX.leftWrapper}>
          <Typography sx={SX.title}>{title}</Typography>
        </Grid2>

        <Grid2 xs={48} sm={48} md={18} lg={18} xl={18} sx={SX.total}>
          {!latency ? (
            <Box sx={SX.row}>
              {icon && <Icon name={icon} size={20} />}
              {!loading ? total : <Icon name="loading" size={20} />}
            </Box>
          ) : (
            <Box sx={SX.latencyWrapper}>
              {!loading ? total : <Icon name="loading" size={20} />}
              <span>ms</span>
            </Box>
          )}
        </Grid2>
      </Styled.Wrapper>
    );
  }
);

ApiUsageAnalyticsSummary.displayName = 'ApiUsageAnalyticsSummary';
